import useReveal from '../hooks/useReveal';

const Home = () => {
  useReveal();

  return (
    <>
      <section className="hero" id="home">
        <div className="hero-content">
          <div className="section-label">Investment Advisory</div>
          <h1>
            Your Financial Future,<br />
            Our Expertise
          </h1>
          <p className="hero-text">
            A SEBI-registered, fee-only investment advisory helping individuals and families build long term wealth through disciplined mutual find investing and strategic SIP planning.
          </p>
          <p className="focus-text">
            Our Focus Is Long-Term Investing, Risk Awareness, And Financial
            Independence. Because Smart Money Decisions Today Secure Your
            Family&apos;s Tomorrow.
          </p>
          <div className="hero-cta">
            <button className="cta-button">Get My Free EMI-to-Wealth Check</button>
          </div>
        </div>
        <div >
          <img src='/my_fundz.png' alt="Financial Growth" style={{ width: "100%", height: "auto", objectFit: "cover" }} />
        </div>
      </section>

            <section className="quick-inquiry">

        <div className="inquiry-content fade-in hero-content">
          {/* <div className="section-label">Support</div> */}
          <h2>Our Visionary Founder</h2>
          <p>
            <strong></strong>
          </p>
          <p>
            Most People Lack Guidance On Financial Planning And Debt Management.
            MyFundz Offers Proven, Jargon-Free, And Long-Term Wealth Creation. Early
            Guidance From A Certified Mutual Fund Service Makes A Big Difference.
          </p>
          <p>Start With A Free EMI-To-Wealth Check Today.</p>
          <button className="cta-button">Get Started Now</button>
        </div>

                <div className="hero-image inquiry-visual">
           <img src='/images/choose_us/1.png' alt="Quick Inquiry" style={{ width: "100%", height: "auto", borderRadius: "20px" }} />
        </div>


      </section>

      <section className="quick-inquiry">
        <div className="hero-image inquiry-visual">
           <img src='/images/home/Union.png' alt="Quick Inquiry" style={{ width: "100%", height: "auto", borderRadius: "20px" }} />
        </div>
        <div className="inquiry-content fade-in hero-content">
          <div className="section-label">Support</div>
          <h2>"Need Help?" – Quick Inquiry</h2>
          <p>
            <strong>Struggling With EMIs, Savings, Or Choosing The Right Investments?</strong>
          </p>
          <p>
            Most People Lack Guidance On Financial Planning And Debt Management.
            MyFundz Offers Proven, Jargon-Free, And Long-Term Wealth Creation. Early
            Guidance From A Certified Mutual Fund Service Makes A Big Difference.
          </p>
          <p>Start With A Free EMI-To-Wealth Check Today.</p>
          <button className="cta-button">Get Started Now</button>
        </div>
      </section>

      <section className="stats-bar">
        <div className="stat-item fade-in">
          <h3>Total Clients</h3>
          <div className="number">500+</div>
        </div>
        <div className="stat-item fade-in">
          <h3>AUM</h3>
          <div className="number">30 Crore+</div>
        </div>
        <div className="stat-item fade-in">
          <h3>Since</h3>
          <div className="number">1985</div>
        </div>
      </section>

      <section className="services" id="services">
        <div className="services-grid">
          <div className="services-visual">
            <img src="/images/home/Rectangle 53.png" alt="Our Services" style={{ width: "100%", height: "auto", borderRadius: "24px", boxShadow: "0 20px 40px rgba(0,0,0,0.1)" }} />
          </div>
          <div className="services-content fade-in">
            <div className="section-label">Our Expertise</div>
            <h2>Overview Of Services</h2>
            <p>
              MyFundz Provides Comprehensive Investment Advisory And Portfolio
              Management Services. We help clients from undefined savings to structural finance planning.
            </p>
            <button className="cta-button">Explore All Services</button>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="cta-container">
          <h2>Ready to Secure Your Future?</h2>
          <p>Looking For A Reliable Financial Advisor Near You?</p>
          <p>
            Whether You&apos;re Starting Early Or Recovering Late, Use The Right Plan
            Works. Get Personalized Guidance On Retirement Or Conflict-Free Mutual Fund
            Advice. Let&apos;s Begin Your Journey Today.
          </p>
          <button className="cta-button white">Let&apos;s Talk Today</button>
        </div>
      </section>
    </>
  );
};

export default Home;
